var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramFinancialPlanning64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./FinancialPlanning64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(3.000000, 4.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8089581,49.1662009 C32.6800178,49.1662009 37.4498715,40.2701214 37.1179925,30.2369878 C36.8553636,22.2973753 32.614281,13.9935728 24.3947445,5.3255805 C16.3808676,13.720756 12.3739292,21.9703351 12.3739292,30.0743178 C12.3739292,40.2676912 20.3724723,49.1662009 25.8089581,49.1662009 Z",
    id: "Focus",
    fill: "#FFCC00",
    transform: "translate(24.754109, 27.245891) rotate(-45.000000) translate(-24.754109, -27.245891) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,44 C43.8710598,44 48.9382201,34.9981712 49,24.9472656 C49.0486654,17.0299479 45.0486654,8.71419271 37,0 C29,8.56268389 25,16.8960172 25,25 C25,35.1933733 31.5635143,44 37,44 Z",
    id: "Oval-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,29 L37,55",
    id: "Line-Copy",
    strokeLinecap: "square"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramFinancialPlanning64);
export default __webpack_public_path__ + "static/media/pictogramFinancialPlanning64.9a0ed4c8898432dc2f88b9398a72b3a3.svg";
export { ForwardRef as ReactComponent };